//polyfill for explorer: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
export default function (x) {
  return (x > 0) - (x < 0) || +x;
}
